import { word } from "@modules/core/utils/i18n"
import { z } from "zod"

export const creditPurchaseSchema = (oldCredit: number | null) =>
  z.object({
    newCredits: z.number().min(-(oldCredit ?? 0), word("box.purchases.modal.credit.formik.error")),
  })

export type CreditPurchaseFormFields = z.infer<ReturnType<typeof creditPurchaseSchema>>
